import React from "react";
import { Box, Grid, Typography } from "@mui/material";

import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { Colors } from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Colors);

const BarChart = ({ setTotalSale, dateChart, data }) => {
  var totalCount = 0;

  const labels = data.map((x) => x.date);
  const data1 = {
    labels: labels,
    datasets: [
      {
        label: `${data?.length} registers`,
        data: data.map((x) => {
          const total =
            Number(x.cash) +
            Number(x.cashApp) +
            Number(x.zelle) +
            Number(x.card) +
            Number(x.other);
          totalCount = totalCount + total;
          setTotalSale(totalCount);
          return total;
        }),
        fill: false,
        borderColor: [
          "rgb(255, 99, 132)",
          "rgb(55, 162, 235)",
          "rgb(255, 206, 86)",
          "rgb(75, 192, 192)",
          "rgb(153, 102, 255)",
        ],

        borderWidth: 1,
        tension: 0.1,
      },
    ],
  };

  return (
    <div>
      <Grid>
        <Box>
          <Typography variant="caption">
            {" "}
            Each day of the Month {dateChart}
          </Typography>
        </Box>
        <Box>
          <Bar
            height={260}
            width={"80%"}
            data={data1}
            options={{
              maintainAspectRatio: false,
              scales: {
                y: {
                  beginAtZero: true,
                  display: true,
                },
                x: {
                  display: false,
                },
              },
            }}
          />
        </Box>
      </Grid>
    </div>
  );
};

export default BarChart;
